import { apiClient } from './apiClient';

export const inventoryService = {
  // Get all inventory items
  async getInventory() {
    return apiClient.get(`/api/cmms/inventory`);
  },

  // Get inventory by warehouse
  async getInventoryByWarehouse(warehouseId) {
    return apiClient.get(`/api/cmms/inventory/warehouse/${warehouseId}`);
  },

  // Get inventory by branch
  async getInventoryByBranch(branchId) {
    return apiClient.get(`/api/cmms/inventory/branch/${branchId}`);
  },

  // Get single inventory item by ID
  async getInventoryById(id) {
    return apiClient.get(`/api/cmms/inventory/${id}`);
  },

  // Get low stock items
  async getLowStockItems() {
    return apiClient.get(`/api/cmms/inventory/low-stock`);
  },

  // Search by barcode
  async scanBarcode(barcode) {
    return apiClient.get(`/api/cmms/inventory/scan/${barcode}`);
  },

  // Create new inventory item
  async createInventory(data) {
    const payload = {
      warehouseId: data.warehouseId ? parseInt(data.warehouseId) : null,
      locationId: data.locationId ? parseInt(data.locationId) : null,
      name: data.name,
      sku: data.sku,
      category: data.category,
      description: data.description || null,
      quantityOnHand: data.quantityOnHand ? parseInt(data.quantityOnHand) : 0,
      minimumQuantity: data.minimumQuantity ? parseInt(data.minimumQuantity) : null,
      reorderPoint: data.reorderPoint ? parseInt(data.reorderPoint) : null,
      unitOfMeasure: data.unitOfMeasure || null,
      unitCost: data.unitCost ? parseFloat(data.unitCost) : null,
      supplierId: data.supplierId ? parseInt(data.supplierId) : null,
      supplierName: data.supplierName || null,
      supplierPartNumber: data.supplierPartNumber || null,
      leadTimeDays: data.leadTimeDays ? parseInt(data.leadTimeDays) : null,
      binLocation: data.binLocation || null,
      barcode: data.barcode || null
    };
    return apiClient.post(`/api/cmms/inventory`, payload);
  },

  // Update inventory item
  async updateInventory(id, data) {
    const payload = {
      warehouseId: data.warehouseId ? parseInt(data.warehouseId) : null,
      locationId: data.locationId ? parseInt(data.locationId) : null,
      name: data.name || null,
      category: data.category || null,
      description: data.description || null,
      minimumQuantity: data.minimumQuantity ? parseInt(data.minimumQuantity) : null,
      reorderPoint: data.reorderPoint ? parseInt(data.reorderPoint) : null,
      unitOfMeasure: data.unitOfMeasure || null,
      unitCost: data.unitCost ? parseFloat(data.unitCost) : null,
      supplierId: data.supplierId ? parseInt(data.supplierId) : null,
      supplierName: data.supplierName || null,
      supplierPartNumber: data.supplierPartNumber || null,
      leadTimeDays: data.leadTimeDays ? parseInt(data.leadTimeDays) : null,
      binLocation: data.binLocation || null,
      barcode: data.barcode || null,
      isActive: data.isActive !== undefined ? data.isActive : null
    };
    return apiClient.put(`/api/cmms/inventory/${id}`, payload);
  },

  // Delete inventory item
  async deleteInventory(id) {
    return apiClient.delete(`/api/cmms/inventory/${id}`);
  },

  // Adjust inventory quantity
  async adjustQuantity(id, quantity, type, userId, notes = null) {
    const params = new URLSearchParams({
      quantity: quantity.toString(),
      type: type, // ADD, REMOVE, ADJUST
      userId: userId.toString()
    });
    if (notes) {
      params.append('notes', notes);
    }
    return apiClient.post(`/api/cmms/inventory/${id}/adjust?${params.toString()}`);
  }
};
